module.exports = __webpack_public_path__ + "assets/img/golden-shield.fb1b398a.png";